<template>
  <SysDialog v-model="dialog_ativo" titulo="Exportação Winthor">
    <template #ativador>
      <v-btn icon @click="dialog_ativo = ! dialog_ativo">
        <v-icon :size="16">mdi-information-outline</v-icon>
      </v-btn>
    </template>

    <ResultadoExportacaoComSucesso :idpedido_systock="props.idpedido_systock" />

    <template #actions>
      <v-btn text @click="dialog_ativo = ! dialog_ativo">
        fechar
      </v-btn>
    </template>
  </SysDialog>
</template>

<script setup>
import {ref} from "vue";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import ResultadoExportacaoComSucesso from '@/components/compra/carrinho/Exportacoes/NativaWinthor/ResultadoExportacaoComSucesso.vue';

const props = defineProps({
  idpedido_systock: Number,
});

const dialog_ativo = ref(false);
</script>
